import { apiFetch } from '@/lib/api'
import type { components } from '@/types/api'

/** Uygulama içi bildirimler (`/api/v1/notifications`, docs/IK-PANEL-PLAN-2.md Faz 3). */
export type AppNotification = components['schemas']['NotificationRead']
export type AppNotificationList = components['schemas']['NotificationList']

export const notificationsApi = {
  list: () => apiFetch<AppNotificationList>('/notifications'),
  read: (id: string) => apiFetch<AppNotification>(`/notifications/${id}/read`, { method: 'POST' }),
  readAll: () => apiFetch<void>('/notifications/read-all', { method: 'POST' }),
}
